/** @jsx React.DOM */
var React = require('react/addons')

var News = React.createClass({displayName: 'News',
  render: function() {
    return React.DOM.div({className: "news"}, 
      React.DOM.h3(null, "WRT web wallet"), 
      React.DOM.p(null, "Try ", React.DOM.a({href: "https://wallet.wrcoin.io/"}, "wallet.wrcoin.io"), " for maximum portability"), 

      React.DOM.h3(null, "WRT node daemon"), 
      React.DOM.p(null, "Source code: ", React.DOM.a({target: "_blank", href: "https://github.com/World-of-Retail-Token/wrtd"}, "Github"))
    )
  }
})

module.exports = News



//////////////////
// WEBPACK FOOTER
// ./src/routes/home/news.jsx
// module id = 471
// module chunks = 0